import React, { useEffect } from "react";
import { Router, Route, Switch, Redirect ,useLocation} from "react-router-dom";
import Main from "../page/main";
import BulkImport from "../Entries/BulkImport";
import Login from "../page/login";
import ViewOrderPage from "../page/view-order";

import { useSelector, useDispatch } from "react-redux";
import history from "../service/history";
import { RtlLtrCssSelector } from "../helper/module";
import SharedPage from "../page/shared";
import { useMediaQuery } from "newmaterial-ui";
import { Logout } from "../hooks/logout";
import RestrictedAccess from "../page/403";
import NewOrderPage from "../page/new-order";
import { RouteDetails } from "../layout/route-details/RouteDetails";
import { SyncReduxLocal } from "../hooks/SyncReduxLocal";
import { GettingStartedLayout } from "../layout/getting-started";
import { MagicLink } from "../components/magicl-ink";
import { ResetPassword } from "../layout/reset-password";

export const RouteManager = () => {
  const authenticated = useSelector((state) => state.LocalData.access_token);
  const dispatch = useDispatch();
  const matches = useMediaQuery("(max-width:600px)");
   
  SyncReduxLocal()
  // useGoogleMapsHook()

 

 

  if(window.location.pathname == "/driver/password-reset"){
   return (<RtlLtrCssSelector>
    <Router history={history}>

    <Route exact path="/driver/password-reset" >
          <ResetPassword />
        </Route> 

       </Router>
    </RtlLtrCssSelector>)
  }


  if (window.location.pathname == '/magic-link') {
    return (<RtlLtrCssSelector>
        <Router history={history}>
            <Switch>
              <Route path="/magic-link"  >
                  <MagicLink />
                </Route>  
                <PrivateRoute2
                authenticated={authenticated}
                dispatch={dispatch}
                name="gettingstarted"
                exact
                path="/gettingstarted" 
                pathname={window.location.pathname+window.location.search}
                >

                <GettingStartedLayout />

                </PrivateRoute2>   
                <PrivateRoute2
                  authenticated={authenticated}
                  path="/BulkImport"
                  dispatch={dispatch}
                  name="BulkImport"
                  exact
                pathname={window.location.pathname+window.location.search}
                >
                  <BulkImport />
                </PrivateRoute2>
                <PrivateRoute2
                  authenticated={authenticated}
                  path="/"
                  dispatch={dispatch}
                  name="Home"
                  exact
                pathname={window.location.pathname+window.location.search}
                >
                  <SharedPage matches={matches} />
                </PrivateRoute2>
            </Switch>
         </Router>
     </RtlLtrCssSelector>)
   }

  return (
    <RtlLtrCssSelector>
      <Router history={history}>

      <Route exact path="/driver/password-reset" >
            <ResetPassword />
          </Route>   
        
      <Route path="/magic-link" >
            <MagicLink />
          </Route>   
          
          <Switch>

          <Route path="/403" >
            <RestrictedAccess />
          </Route>


          <Route path="/logout" >
            <Logout />
          </Route>
          <Route path="/login" >
            <Login />
          </Route>

          {/* <PrivateRoute
            authenticated={authenticated}
            path="/neworder"
            dispatch={dispatch}
            name="Home"
            exact
          >
            <NewOrderPage />
          </PrivateRoute> */}
          {/* 
          <PublicRoute path="/login" isAuthenticated={authenticated}>

            <Login tokenCheck={false} />
          </PublicRoute> */}

<PrivateRoute
          authenticated={authenticated}
          dispatch={dispatch}
          name="gettingstarted"
          exact
          path="/gettingstarted" >

          <GettingStartedLayout />

        </PrivateRoute>   
          <PrivateRoute
            authenticated={authenticated}
            path="/BulkImport"
            dispatch={dispatch}
            name="BulkImport"
            exact
          >
            <BulkImport />
          </PrivateRoute>
          <PrivateRoute
            authenticated={authenticated}
            path="/"
            dispatch={dispatch}
            name="Home"
          >
            <SharedPage matches={matches} />
          </PrivateRoute>
          {/* <PrivateRoute path="/route/:id/:stop"
            authenticated={authenticated}
            dispatch={dispatch}
            name="RouteDetails"
          >
            <RouteDetails />
          </PrivateRoute> */}
          {/* <PrivateRoute
            authenticated={authenticated}
            path="/phubd"
            dispatch={dispatch}
            name="phubd"
          >
            <SharedPage matches={matches} />
          </PrivateRoute> */}
          {/* <PrivateRoute
            authenticated={authenticated}
            path="/ondemand"
            dispatch={dispatch}
            name="ondemand"
          >
            <SharedPage matches={matches} />
          </PrivateRoute> */}

          {/* <PrivateRoute
            authenticated={authenticated}
            path="/Ondemand"
            dispatch={dispatch}
            name="Home"
            exact
          >
            <SharedPage matches={matches} />
          </PrivateRoute> */}
          {/* <PrivateRoute
            authenticated={authenticated}
            path="/order/:id"
            dispatch={dispatch}
            name="Home"
            exact
          >
            <SharedPage matches={matches} />
          </PrivateRoute> */}




          {/* 
                  <PrivateRoute
                    authenticated={authenticated}
                    path="/order/:orderId"
                    dispatch={dispatch}
                    name="Home"
                >
                    <ViewOrderPage />
                </PrivateRoute> */}


          {/* <PrivateRoute
                    authenticated={authenticated}
                    path="/"
                    dispatch={dispatch}
                    name="Home"
                >
                    <Main />
                </PrivateRoute> */}
        </Switch>
      </Router>
    </RtlLtrCssSelector>
  );
};

function PrivateRoute({ children, authenticated, path, dispatch, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authenticated ? (
          children
        ) : (
           <Redirect
              to={{
               pathname: "/login",
               state: { from: location },
          }}
           />
        )
      }
    />
  );
}
function PrivateRoute2({ children, authenticated, path , pathname, dispatch, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authenticated ? (
          children
        ) : (
           <Redirect
              to={{
               pathname: pathname,
               state: { from: location },
          }}
           />
        )
      }
    />
  );
}

function PublicRoute({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/Ondemand",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
